import { Module } from "vuex";
import { ICountdowns, INASATVSchedule, IStaticDataLoadingStatus, IStoreStaticData, INASAStreams, ISpaceStationBlog, INASALiveEvents } from "../store-services/staticdata.types";

export const UPDATE_NASATVSCHEDULE = "UPDATE_NASATVSCHEDULE"
export const UPDATE_NASATVSCHEDULE_STATUS = "UPDATE_NASATVSCHEDULE_STATUS"
export const UPDATE_SPACESTATIONBLOG = "UPDATE_SPACESTATIONBLOG"
export const UPDATE_SPACESTATIONBLOG_STATUS = "UPDATE_SPACESTATIONBLOG_STATUS"
export const UPDATE_STREAMS = "UPDATE_STREAMS"
export const UPDATE_STREAMS_STATUS = "UPDATE_STREAMS_STATUS"
export const UPDATE_LIVEEVENTS = "UPDATE_LIVEEVENTS"
export const UPDATE_LIVEEVENTS_STATUS = "UPDATE_LIVEEVENTS_STATUS"
export const UPDATE_COUNTDOWNS = "UPDATE_COUNTDOWNS"
export const UPDATE_COUNTDOWNS_STATUS = "UPDATE_COUNTDOWNS_STATUS"

export const staticDataStore: Module<IStoreStaticData, any> = {
  namespaced: true,
  state: {
    nasatvschedule: {
      timestamp: new Date(0),
      status: "error"
    },
    spacestationblog: {
      timestamp: new Date(0),
      status: "error"
    },
    streams: {
      timestamp: new Date(0),
      status: "error"
    },
    liveevents: {
      timestamp: new Date(0),
      status: "error"
    },
    countdowns: {
      timestamp: new Date(0),
      status: "error"
    }
  },
  mutations: {
    [UPDATE_NASATVSCHEDULE](state, payload: INASATVSchedule) {
      state.nasatvschedule = payload
    },
    [UPDATE_NASATVSCHEDULE_STATUS](state, payload: IStaticDataLoadingStatus) {
      state.nasatvschedule.status = payload
    },
    [UPDATE_SPACESTATIONBLOG](state, payload: ISpaceStationBlog) {
      state.spacestationblog = payload
    },
    [UPDATE_SPACESTATIONBLOG_STATUS](state, payload: IStaticDataLoadingStatus) {
      state.spacestationblog.status = payload
    },
    [UPDATE_STREAMS](state, payload: INASAStreams) {
      state.streams = payload
    },
    [UPDATE_STREAMS_STATUS](state, payload: IStaticDataLoadingStatus) {
      state.streams.status = payload
    },
    [UPDATE_LIVEEVENTS](state, payload: INASALiveEvents) {
      state.liveevents = payload
    },
    [UPDATE_LIVEEVENTS_STATUS](state, payload: IStaticDataLoadingStatus) {
      state.liveevents.status = payload
    },
    [UPDATE_COUNTDOWNS](state, payload: ICountdowns) {
      state.countdowns = payload
    },
    [UPDATE_COUNTDOWNS_STATUS](state, payload: IStaticDataLoadingStatus) {
      state.countdowns.status = payload
    },
  },
  actions: {
    updateNASATVSchedule: () => {},
    updateSpaceStationBlog: () => {},
    updateStreams: () => {},
    updateLiveEvents: () => {},
    updateCountdowns: () => {}
  },
  getters: {
    getNASATVSchedule: (state) => {
      return state.nasatvschedule
    },
    getSpaceStationBlog: (state) => {
      return state.spacestationblog
    },
    getStreams: (state) => {
      return state.streams
    },
    getLiveEvents: (state) => {
      return state.liveevents
    },
    getCountdowns: (state) => {
      return state.countdowns
    }
  }
}